import usePrivateAxios from '@/common/api/usePrivateAxios'
import { useMutation } from '@tanstack/react-query'
import { AxiosError } from 'axios'

type UseDeleteGovernmentAllocationProductDistributionProps = {
  onSuccess: () => void
  onError: (error: AxiosError) => void
}

export const useDeleteGovernmentAllocationProductDistribution = ({
  onSuccess,
  onError,
}: UseDeleteGovernmentAllocationProductDistributionProps) => {
  const privateAxios = usePrivateAxios()

  return useMutation({
    mutationKey: ['deleteGovernmentAllocationProductDistribution'],
    mutationFn: async (productDistributionId?: string) => {
      return privateAxios.put(`/billing/government_allocation_product_distributions/${productDistributionId}/stale`)
    },
    onSuccess,
    onError,
  })
}
